import React from 'react';
import { Stack, Text } from '@moda/om';
import { COUNTRIES, formatPrice } from '@moda/portal-stanchions';
import { useUser } from '../../hooks/useUser';

import './ZeroCredit.scss';

interface Props {
  currency?: string;
}

export const ZeroCredit: React.FC<Props> = () => {
  const {
    user: { countryCode }
  } = useUser();

  const country = COUNTRIES.find(country => country.alpha2Code === countryCode);
  const currency = country?.currencyCode;
  const formattedTotal = formatPrice(currency, 0);

  return (
    <div className="ZeroCredit">
      <Stack space={2} className="ZeroCredit__preview">
        <span>Remaining Credit ({currency})</span>
        <Stack space={2} justifyContent="space-between" direction="horizontal">
          <span>{formattedTotal}</span>
        </Stack>
        <Text treatment="body2" color="cement">
          You do not have any site credit available at this time.
        </Text>
      </Stack>
    </div>
  );
};
